import React from 'react'
import { connect } from 'react-redux'
import { FiXCircle } from 'react-icons/fi'
import { Formik, Form } from 'formik'
import styled from 'styled-components'

// Configs
import { uploadInvoiceConfig } from '../_configs'

// Services
import { businessService, documentsService } from '../_services'

// Helpers
import { history } from '../_helpers'

// Actions
import { userActions, dealActions, notificationsActions } from '../_actions'

// Components
import Field from './FieldNew'
import { Button } from './Button'

// Constants
import ROUTES from '../_constants/routes'

// Assets
import UploadedInvoiceIcon from '../assets/img/pre-int-icn-active.png'

// Styled Components
const StyledUploadInvoices = styled.div`
  margin-top: 20px;

  .invoice-to-upload {
    border-radius: 4px;
    padding: 10px 5px;
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0px;
    }

    .invoice-header,
    .invoice-form {
      padding: 10px;
    }

    .invoice-header {
      display: flex;
      border-bottom: none;
      align-items: center;
      justify-content: space-between;
      padding: 10px 15px;

      div {
        display: flex;
        align-items: center;
      }

      img,
      span {
        margin-right: 10px;
      }

      img {
        height: 40px;
      }

      .invoice-name {
        font-size: 20px;
        text-align: center;
      }

      .remove-invoice-icon {
        height: 25px;
        width: 25px;
        opacity: 0.5;
        transition: all 0.2s ease-in-out;
        cursor: pointer;

        &:hover {
          opacity: 0.75;
        }
      }
    }

    .invoice-form {
      .field {
        margin-top: 15px;
        &:first-of-type {
          margin-top: 0;
        }
      }
      .submit-btn {
        display: flex;
        margin: 0 auto;
        margin-top: 50px;
      }
    }
  }

  .button-row {
    text-align: center;
  }

  .submit-btn {
    &:disabled {
      opacity: 0.5;
    }
  }
`

const initialValue = {
  document_type: ``,
  debtor_name: ``,
  face_value: 0,
  payment_terms: ``,
  other_payment_terms: 0,
  document_issue_date_month: ``,
}

const renderIntialValues = (invoices) => {
  let initialValues = invoices.map((val, i) => {
    if (val) {
      return {
        ...initialValue,
        ...invoices[i],
      }
    } else {
      return { ...initialValue }
    }
  })
  return initialValues
}

const updateInvoice = (attr, val, invoice, invoiceIndex) => {
  if (attr === `debtor_name`) {
    businessService.createBusinessDebtor(invoice.business_id, invoice.data_source, val).then((resp) => {
      documentsService.updateInvoice(invoice.id, `debtor_id`, resp.debtor_id)
    })
  } else if (
    attr === `face_value` ||
    attr === `payment_terms` ||
    attr === `other_payment_terms` ||
    attr === `invoice_number`
  ) {
    documentsService.updateInvoice(invoice.id, attr, val)
  } else if (attr === `document_type` || attr === `document_issue_date`) {
    documentsService.updateDocument(invoice.document_id, attr, val)
  }
}

const UploadInvoices = ({
  invoices,
  removeInvoice,
  setFlowStep,
  user,
  deal,
  updateDeal,
  showNotification,
  onSubmit = null,
  showHeader = true,
}) => {
  return (
    <StyledUploadInvoices>
      <Formik
        initialValues={{
          uploadedInvoices: renderIntialValues(invoices),
        }}
        onSubmit={(values, action) => {
          invoices.map((invoice, i) => {
            documentsService.updateInvoice(invoice.id, 'pending', true)

            if (values.uploadedInvoices[i].payment_terms === `Other`) {
              documentsService.updateInvoice(
                invoice.id,
                'payment_terms',
                `Net ${values.uploadedInvoices[i].other_payment_terms}`
              )
            }
          })
          if (user.user_type != 'lender') {
            setFlowStep(user.id, `invoices_added_by_new_user`)
          }

          if (deal.deal_status === `created` || deal.deal_status === `submitted`) {
            updateDeal(`deal_status`, `pending`, deal.id)
          }

          // TODO:
          // - change the timeout, make sure this only happens after each one is uploaded
          setTimeout(() => {
            // Check submit callback
            if (onSubmit === null) history.push(ROUTES.confirm_form)
            else onSubmit()

            showNotification({
              type: `success`,
              message: `Documents succesfully uploaded.`,
            })
          }, 3000)
        }}
      >
        {({ setFieldTouched, setFieldValue, values, errors, touched, isValid, validateForm, isSubmitting }) => (
          <Form>
            {invoices.map((invoice, i) => (
              <div className={`invoice-to-upload`} key={i}>
                {/* Header */}
                {showHeader && (
                  <div className={`invoice-header`}>
                    <div>
                      <img alt={`Uploaded Invoice`} src={UploadedInvoiceIcon} />
                      <span className={`invoice-name`}>{invoice.document_name || invoice[0].document_name}</span>
                    </div>
                    <FiXCircle className={`remove-invoice-icon`} onClick={() => removeInvoice(invoice.id, i)} />
                  </div>
                )}

                {/* Form */}
                <div className={`invoice-form`}>
                  {uploadInvoiceConfig.map((field, ii) => (
                    <Field
                      errors={errors}
                      field={field}
                      handleBlur={(name, attr, val) => {
                        setFieldTouched(name, true)
                        updateInvoice(attr, val, invoice, i)
                      }}
                      handleChange={(attr, val) => setFieldValue(attr, val)}
                      index={i}
                      key={ii}
                      touched={touched}
                      values={values}
                    />
                  ))}
                </div>
              </div>
            ))}
            {user.user_type != 'lender' && (
              <div className="button-row">
                <Button
                  buttonType={`button`}
                  className={`submit-btn`}
                  disabled={isSubmitting}
                  text={`Submit ${invoices.length} receivable${invoices.length !== 1 ? 's' : ''}`}
                  type={`submit`}
                />
              </div>
            )}
          </Form>
        )}
      </Formik>
    </StyledUploadInvoices>
  )
}

function mapStateToProps(state, ownprops) {
  const { user, business, deal } = state
  return {
    user,
    business: ownprops.business ? ownprops.business : business,
    deal: ownprops.deal ? ownprops.deal : deal.deal,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateDeal: (attr, val, dealId) => {
      dispatch(dealActions.updateDeal(attr, val, dealId))
    },
    setFlowStep: (userId, value) => {
      dispatch(userActions.updateUser('flow_step', value, userId))
    },
    showNotification: (notification) => {
      dispatch(notificationsActions.showNotification(notification))
    },
  }
}

const connectedUploadInvoices = connect(mapStateToProps, mapDispatchToProps)(UploadInvoices)
export { connectedUploadInvoices as UploadInvoices }
